import React from 'react';
// import { useNavigate } from 'react-router-dom';

import { Button} from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-cards';

import { Navigation, Pagination, EffectCards } from 'swiper/modules';

const SwiperApp = () => {

  // const navigate = useNavigate();

  const handleClick = (path) => {
    window.location.href=(path);
  };

  const cards = [
    {
      id: 1,
      name: 'Decoration',
      tools: [{ next: "HTML, CSS" }, { node: "JS" }, { mongo: "MongoDB" }],
      description: 'An Event decoration website',
      liveText: "view live",
      githubText: "view on github",
      button1: "https://yuceevents.netlify.app/",
      button2: "View on Github",
      button3: "btn3",
      button4: "btn3",
      content: "A simple event decorations website with booking and rich photo gallery.",
    },

    {
      id: 2,
      name: 'Delivery',
      tools: [{ react: "React" }, { redux: "Redux" }, { firebase: "Firebase" }],
      description: 'A School Exam Portal',
      liveText: "view live",
      githubText: "view on github",
      button1: "https://www.boxbroda.com/",
      button2: "View on Github",
      button3: "btn3",
      button4: "btn3",
      content: "A courier website with a real time shipment tracking functionality.",
    },

    {
      id: 3,
      name: 'Fintech',
      tools: [{ vue: "Vue.js" }, { express: "Express" }, { mysql: "MySQL" }],
      description: 'A Mobile Bank App',
      liveText: "view live",
      githubText: "view on github",
      button1: "/",
      button2: "View on Github",
      button3: "btn3",
      button4: "btn3",
      content: "Empty Card",
    },
  ];

  return (
    <div className="container-fluid tinder-cards mt-5">
      <Swiper
        className='swiper'
        modules={[Navigation, Pagination, EffectCards]}
        effect="cards"
        slidesPerView={1}
        centeredSlides={true}
        spaceBetween={0}
        slideShadows={true}
        slideActiveClass={'swiper-slide-active'}
        navigation
        pagination={{ clickable: true }}
        onSwiper={(swiper) => console.log(swiper)}
        onSlideChange={() => console.log('slide change')}
      >
        {cards.map((card) => (
          <SwiperSlide key={card.id}>
            <div className={`card m-0 overflow-hidden`}>
              <div className="card-contents p-3">
                <h3 className='mb-4 fw-bolder'>{card.name} <i className='bi bi-arrow-up-right-square-fill' style={{ color: "#0099ff" }}></i></h3>
                <p className='fw-bolder'>{card.description}</p>
                <div className='tools mb-3'>
                  {card.tools.map((tool, index) => (
                    <span key={index} className={`py-1 ${index === 0 ? "one" : index === 1 ? 'two' : index === 2 ? "three" : ""}`}>
                      {Object.values(tool)}
                    </span>
                  ))}
                </div>
                <div className="btn-group btn-group-sm me-3 desktop" role="group">
                  <button type="button" className="btn btn-outline-secondary rounded-5 rounded-end-0">Desktop</button>
                  <button type="button" className="btn btn-outline-secondary rounded-5 rounded-start-0">
                    <i className='bi bi-phone'></i>
                  </button>
                </div>
                <div className="btn-group btn-group-sm phone" role="group">
                  <button type="button" className="btn btn-outline-secondary rounded-5 rounded-end-0">Desktop</button>
                  <button type="button" className="btn btn-outline-secondary rounded-5 rounded-start-0 ">
                    <i className='bi bi-laptop'></i>
                  </button>
                </div>
                <p className='mt-3 pe-4 description'>{card.content}</p>

                <Button variant='contained' size='small' className='mt-2' onClick={() => handleClick(card.button1)}>{card.liveText} <i className='bi bi-arrow-right-circle-fill ms-3'></i></Button><br />

                <Button variant='contained' className='btn bg-git mt-2' size='small fw-light'>{card.githubText} <i className='bi bi-github ms-3'></i></Button>
              </div>

              <div className="svg">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#0099ff" fillOpacity="1" d="M0,224L80,229.3C160,235,320,245,480,240C640,235,800,213,960,176C1120,139,1280,85,1360,58.7L1440,32L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default SwiperApp;
